/**
 * Custom select
 * @requires https://github.com/Choices-js/Choices
*/
import {Modal} from "bootstrap";

const formWizard = (() => {

  let currentStep = 0,
      form = document.getElementById('form-wizard'),
      contactForm = document.getElementById('form-wizard-contact'),
      prevBtn = document.getElementById('prevBtn'),
      nextBtn = document.getElementById('nextBtn'),
      contactSubmit = document.getElementById('contactSubmit'),
      bubble = document.getElementById('wizard-bubble');

  if (form === null || contactForm === null) return;

  showStep(currentStep);

  function showStep(n) {
    let step = document.getElementsByClassName('wizard-step');
    step[n].style.display = 'block';
    switch (n) {
      case 0:
        bubble.innerHTML = 'Make payments<br>possible.<br>everytime. <br>everywhere.';
        break;
      case 1:
        bubble.innerHTML = 'We provide<br>more than 20<br>payment <br>methods.';
        break;
      case 2:
        bubble.innerHTML = 'Payment<br>made easy<br>and<br>convenient.';
        break;
      default:
        bubble.innerHTML = 'Make payments<br>possible.<br>everytime. <br>everywhere.';
    }
    if (n == 0) {
      prevBtn.style.display = 'none';
    } else {
      prevBtn.style.display = 'inline-flex';
    }
    if (n == (step.length - 1)) {
      nextBtn.innerHTML = '<span>Submit<i class="pi-chevron-right ms-1"></i></span>';
    } else {
      nextBtn.innerHTML = '<span>Next<i class="pi-chevron-right ms-1"></i></span>';
    }
    fixStepIndicator(n)
  }

  function nextPrev(n) {
    let step = document.getElementsByClassName('wizard-step');
    if (n == 1 && !validateForm()) return false;
    if ((currentStep + n) >= step.length) {
      const formData = new FormData(form);
      if(testHCaptcha(formData) === false) return false;
      sendAjax(formData);
      closeModal('getStartedModal');
      new Modal(document.getElementById('succesModal')).show();
      return false;
    }
    step[currentStep].style.display = 'none';
    currentStep = currentStep + n;
    showStep(currentStep);
    return false;
  }

  function validateForm() {
    let x, y, i, valid = true;
    x = document.getElementsByClassName('wizard-step');
    y = x[currentStep].getElementsByClassName('wizard-input');
    for (i = 0; i < y.length; i++) {
      if (y[i].checkValidity() === false) {
        y[i].className += ' is-invalid';
        valid = false;
      }
    }
    if (valid) {
      document.getElementsByClassName('step-indicator')[currentStep].className += ' finish';
    }
    return valid;
  }

  function sendAjax(formData) {
    const xhr = new XMLHttpRequest();

    xhr.open('POST', '/send-request/');
    xhr.send(formData);
    xhr.onload = function() {
        return xhr.status === 200;
    }
  }

  function submitContactForm() {
    const formData = new FormData(contactForm);
    if(testHCaptcha(formData) === false) return false;
    sendAjax(formData);
    closeModal('contactModal');
    new Modal(document.getElementById('succesModal')).show();
  }

  function closeModal(id) {
    const modalElement = document.getElementById(id);
    const modalInstance = Modal.getInstance(modalElement)
    modalInstance.hide();
  }

  function testHCaptcha(formData) {
    const gRecaptcha = formData.get('g-recaptcha-response');
    const hCaptcha = formData.get('h-captcha-response');
    return gRecaptcha !== '' && hCaptcha !== '';
  }


  function fixStepIndicator(n) {
    var i, x = document.getElementsByClassName('step-indicator');
    for (i = 0; i < x.length; i++) {
      x[i].className = x[i].className.replace(' active', '');
    }
    x[n].className += ' active';
  }

  prevBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    nextPrev(-1);
    return false;
  });
  nextBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    nextPrev(1);
    return false;
  });
  form.addEventListener('submit', function (e) {
    e.stopPropagation();
    nextPrev(1);
    return false;
  });
  contactSubmit.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    submitContactForm();
    return false;
  });
  contactForm.addEventListener('submit', function (e) {
    e.preventDefault();
    e.stopPropagation();
    submitContactForm();
    return false;
  });

})();

export default formWizard;
